import axios from 'axios';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };

  var t,
      e = {},
      r = Object.prototype,
      n = r.hasOwnProperty,
      o = Object.defineProperty || function (t, e, r) {
    t[e] = r.value;
  },
      i = "function" == typeof Symbol ? Symbol : {},
      a = i.iterator || "@@iterator",
      c = i.asyncIterator || "@@asyncIterator",
      u = i.toStringTag || "@@toStringTag";

  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }

  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }

  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
        a = Object.create(i.prototype),
        c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }

  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }

  e.wrap = wrap;
  var h = "suspendedStart",
      l = "suspendedYield",
      f = "executing",
      s = "completed",
      y = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
      v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);

  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }

  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);

      if ("throw" !== c.type) {
        var u = c.arg,
            h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }

      a(c.arg);
    }

    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }

        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }

  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");

      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }

      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;

        if (c) {
          var u = maybeInvokeDelegate(c, n);

          if (u) {
            if (u === y) continue;
            return u;
          }
        }

        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);

        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }

        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }

  function maybeInvokeDelegate(e, r) {
    var n = r.method,
        o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }

  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }

  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }

  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;

      if (!isNaN(e.length)) {
        var o = -1,
            i = function next() {
          for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;

          return next.value = t, next.done = !0, next;
        };

        return i.next = i;
      }
    }

    throw new TypeError(typeof e + " is not iterable");
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
        r = [];

    for (var n in e) r.push(n);

    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;

      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }

      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
            a = i.completion;
        if ("root" === i.tryLoc) return handle("end");

        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
              u = n.call(i, "finallyLoc");

          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];

        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }

      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];

        if (r.tryLoc === t) {
          var n = r.completion;

          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }

          return o;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var b64Decode = function b64Decode(str) {
  return window.atob(str);
};

var b64Encode = function b64Encode(str) {
  return window.btoa(str);
};

var stringToArrayBuffer = function stringToArrayBuffer(string) {
  var buf = new ArrayBuffer(string.length);
  var bufView = new Uint8Array(buf);

  for (var i = 0, strLen = string.length; i < strLen; i += 1) {
    bufView[i] = string.charCodeAt(i);
  }

  return buf;
};

var arrayBufferToString = function arrayBufferToString(arrayBuffer) {
  return String.fromCharCode.apply(null, Array.from(new Uint8Array(arrayBuffer)));
};

var encryptWithPublicKey = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(plainText, publicKey, encodeBase64) {
    var publicKeyHeader, publicKeyFooter, publicKeyContent, binaryString, publicKeyBuffer, dataBuffer, encrypted, encryptedString;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (encodeBase64 === void 0) {
            encodeBase64 = false;
          }

          publicKeyHeader = "-----BEGIN PUBLIC KEY-----";
          publicKeyFooter = "-----END PUBLIC KEY-----";
          publicKeyContent = publicKey.substring(publicKeyHeader.length, publicKey.length - publicKeyFooter.length - 1);
          binaryString = b64Decode(publicKeyContent);
          publicKeyBuffer = stringToArrayBuffer(binaryString);
          dataBuffer = stringToArrayBuffer(plainText);
          _context.next = 9;
          return window.crypto.subtle.importKey("spki", publicKeyBuffer, {
            name: "RSA-OAEP",
            hash: {
              name: "SHA-256"
            }
          }, false, ["encrypt"]).then(function (importedKey) {
            return window.crypto.subtle.encrypt({
              name: "RSA-OAEP",
              hash: {
                name: "SHA-256"
              }
            }, importedKey, dataBuffer);
          });

        case 9:
          encrypted = _context.sent;
          encryptedString = arrayBufferToString(encrypted);

          if (!encodeBase64) {
            _context.next = 13;
            break;
          }

          return _context.abrupt("return", b64Encode(encryptedString));

        case 13:
          return _context.abrupt("return", encryptedString);

        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function encryptWithPublicKey(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var enums = {
  source: ["strapi", "sms_v11"]
};

var keyFormatter = function keyFormatter(key) {
  return key.replace(/ /g, "_").toUpperCase();
};

var createEnumMap = function createEnumMap(enums, formatter) {
  if (enums === void 0) {
    enums = [];
  }

  if (formatter === void 0) {
    formatter = keyFormatter;
  }

  var enumMapToReturn = {};
  enums.forEach(function (enumKey) {
    if (enumKey === void 0) {
      enumKey = "";
    }

    enumMapToReturn[formatter(enumKey)] = enumKey;
  });
  return enumMapToReturn;
};

var REQUEST_TIMEOUT = 4000;
var STRAPI_REQUEST_TIMEOUT = 5000;
var SOURCE = /*#__PURE__*/createEnumMap(enums.source);
var localisable = {
  somethingWentWrong: "Something went wrong"
};

var getStrapiAxiosInstance = function getStrapiAxiosInstance() {
  return axios.create({
    baseURL: process.env.GATSBY_STRAPI_SERVER_BASE_URL + "/api",
    headers: {
      Authorization: "Bearer " + process.env.GATSBY_STRAPI_API_TOKEN
    },
    timeout: STRAPI_REQUEST_TIMEOUT
  });
};

var allLocationsListsEndpoints = {
  allLocationsLists: function allLocationsLists(_ref) {
    var locationId = _ref.locationId,
        queryString = _ref.queryString;
    var finalUrl = "/all-locations-lists";

    if (locationId) {
      finalUrl += "/" + locationId;
    }

    if (queryString) {
      finalUrl += "?" + queryString;
    }

    return finalUrl;
  }
};
var allFacilitiesListsEndpoints = {
  allFacilitiesLists: function allFacilitiesLists(_ref2) {
    var strapiFid = _ref2.strapiFid,
        queryString = _ref2.queryString;
    var finalUrl = "/all-facilities-lists";

    if (strapiFid) {
      finalUrl += "/" + strapiFid;
    }

    if (queryString) {
      finalUrl += "?" + queryString;
    }

    return finalUrl;
  }
};
var viewRatesPagesEndpoints = {
  viewRatesPages: function viewRatesPages(_ref3) {
    var viewRatesPageId = _ref3.viewRatesPageId,
        queryString = _ref3.queryString;
    var finalUrl = "/view-rates-pages";

    if (viewRatesPageId) {
      finalUrl += "/" + viewRatesPageId;
    }

    if (queryString) {
      finalUrl += "?" + queryString;
    }

    return finalUrl;
  }
};

var baseErrorHandler = function baseErrorHandler(error) {
  console.log(error);
};

var strapiErrorHandler = function strapiErrorHandler(error) {
  baseErrorHandler(error);

  var _error$response = error.response,
      _error$response2 = _error$response === void 0 ? {} : _error$response,
      _error$response2$data = _error$response2.data,
      _error$response2$data2 = _error$response2$data === void 0 ? {} : _error$response2$data,
      errorObj = _error$response2$data2.error,
      _error$response2$data3 = _error$response2$data2.error,
      _error$response2$data4 = _error$response2$data3 === void 0 ? {
    status: 500,
    name: "ServerError"
  } : _error$response2$data3,
      status = _error$response2$data4.status,
      type = _error$response2$data4.name;

  return Promise.reject({
    type: type,
    status: status,
    body: errorObj
  });
};

var strapiResponseHandler = function strapiResponseHandler(response) {
  return Promise.resolve({
    status: response.status,
    data: response.data
  });
};

var formatErrors = function formatErrors(errors) {
  if (errors.type && errors.type !== "InvalidJSON") {
    var _errors$body = errors.body,
        _errors$body2 = _errors$body === void 0 ? {} : _errors$body,
        _errors$body2$errors = _errors$body2.errors,
        _errors$body2$errors2 = _errors$body2$errors === void 0 ? [] : _errors$body2$errors,
        _errors$body2$errors3 = _errors$body2$errors2[0],
        _errors$body2$errors4 = _errors$body2$errors3 === void 0 ? {} : _errors$body2$errors3,
        _errors$body2$errors5 = _errors$body2$errors4.error_code,
        errorCode = _errors$body2$errors5 === void 0 ? "" : _errors$body2$errors5,
        _errors$body2$errors6 = _errors$body2$errors4.error_message,
        errorMessage = _errors$body2$errors6 === void 0 ? "" : _errors$body2$errors6,
        _errors$body2$errors7 = _errors$body2$errors4.__all__,
        _errors$body2$errors8 = _errors$body2$errors7 === void 0 ? [] : _errors$body2$errors7,
        _errors$body2$errors9 = _errors$body2$errors8[0],
        _errors$body2$errors10 = _errors$body2$errors9 === void 0 ? {} : _errors$body2$errors9,
        _errors$body2$errors11 = _errors$body2$errors10.error_message,
        integrityError = _errors$body2$errors11 === void 0 ? "" : _errors$body2$errors11,
        status = errors.status;

    if (errorCode || integrityError) {
      if (status === 500) {
        return {
          errorCode: errorCode,
          errorMessage: localisable.somethingWentWrong
        };
      }

      return {
        errorCode: errorCode,
        errorMessage: errorMessage || integrityError
      };
    }
  }

  return {
    errorMessage: localisable.somethingWentWrong
  };
};

var smsErrorHandler = function smsErrorHandler(error) {
  baseErrorHandler(error);

  var code = error.code,
      _error$response = error.response,
      _error$response2 = _error$response === void 0 ? {} : _error$response,
      _error$response2$stat = _error$response2.status,
      status = _error$response2$stat === void 0 ? 500 : _error$response2$stat,
      _error$response2$data = _error$response2.data,
      body = _error$response2$data === void 0 ? {} : _error$response2$data;

  var formatParams = {
    type: "InvalidJSON",
    status: "",
    body: {}
  };

  if (status >= 500) {
    formatParams = {
      type: "ServerError",
      status: status,
      body: body
    };
  }

  if (status <= 501) {
    formatParams = {
      type: "ApplicationError",
      status: status,
      body: body
    };
  }

  var _formatErrors = formatErrors(formatParams),
      _formatErrors$errorCo = _formatErrors.errorCode,
      errorCode = _formatErrors$errorCo === void 0 ? code : _formatErrors$errorCo,
      errorMessage = _formatErrors.errorMessage;

  return Promise.reject({
    errorMessage: errorMessage,
    status: status,
    code: errorCode
  });
};

var smsResponseHandler = function smsResponseHandler(response) {
  return Promise.resolve({
    status: response.status,
    data: response.data
  });
};

var decodeParseAndGetAPIKeyForFacility = function decodeParseAndGetAPIKeyForFacility(facilityId) {
  var apiKeysPerFidJSON = JSON.parse(window.atob(process.env.GATSBY_SMS_API_KEY || ""));
  return apiKeysPerFidJSON[facilityId];
};

var getEncAndEncodedApiKey = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(facilityId, facilityPubKey) {
    var apiKey;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiKey = decodeParseAndGetAPIKeyForFacility(facilityId);
          _context.next = 3;
          return encryptWithPublicKey(apiKey, facilityPubKey, true);

        case 3:
          return _context.abrupt("return", _context.sent);

        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function getEncAndEncodedApiKey(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var activeStatusFilterApplicableConfigTypes = ["Unit_Type", "Payment_Method", "Card_Processor"];
var smsEndpoints = {
  keySearch: "/key/search",
  facilitiesKeySearch: "/key/facility/search",
  encryptId: function encryptId(id) {
    return "/auth/encrypt/" + id;
  },
  decryptPublicId: function decryptPublicId(publicId) {
    return "/auth/decrypt/" + publicId;
  },
  cardProcessorAuth: "/financial/auth/card-processor",
  configurationSearch: "/configuration/search",
  facilitySearch: "/facility/search",
  facilitySearchAll: "/facility/search/all",
  ledgerHistoryReport: "/report/ledger-history",
  paymentInfo: "/payment/info",
  pay: "/financial/pay",
  payAndMoveIn: "/occupancy/pay-and-move-in",
  payAndReserve: "/reservation/pay-and-reserve",
  rentalInfo: "/rental/info",
  rentalBillAhead: "/rental/bill-ahead",
  rentalPromoPlans: "rental/promo-plans",
  tenantAutoPayEnable: function tenantAutoPayEnable(ledgerId) {
    return "/tenant/" + ledgerId + "/auto-pay/enable";
  },
  tenantAutoPayDisable: function tenantAutoPayDisable(ledgerId) {
    return "/tenant/" + ledgerId + "/auto-pay/disable";
  },
  tenantChangePassword: "/tenant/auth/change-password",
  tenantCreate: "/tenant",
  tenantUpdate: function tenantUpdate(tenantId) {
    return "/tenant/" + tenantId;
  },
  isDuplicateTenant: "/tenant/is-duplicate",
  tenantSearch: "/tenant/search",
  tenantSignIn: "/tenant/auth/sign-in",
  tenantSignOut: "/tenant/auth/sign-out",
  tenantSignUp: function tenantSignUp(tenantId) {
    return "/tenant/auth/" + tenantId + "/sign-up";
  },
  tenantForgotPassword: "/tenant/auth/forgot-password",
  tenantSendAccessCode: "/tenant/auth/send-access-code",
  unitSearch: "/unit/search",
  unitAggregation: "/unit/aggregation",
  reservationSearch: "/reservation/search"
};

var getSmsAxiosInstance = function getSmsAxiosInstance() {
  return axios.create({
    baseURL: process.env.GATSBY_V11_SERVER_BASE_URL,
    timeout: REQUEST_TIMEOUT
  });
};

var to = function to(promise) {
  return promise.then(function (data) {
    return [null, data];
  })["catch"](function (err) {
    return [err, {}];
  });
};

var getRelevantAxiosInstance = function getRelevantAxiosInstance(source) {
  switch (source) {
    case SOURCE.STRAPI:
      return getStrapiAxiosInstance();

    case SOURCE.SMS_V11:
      return getSmsAxiosInstance();

    default:
      return null;
  }
};

var getRelevantErrorHandler = function getRelevantErrorHandler(source) {
  switch (source) {
    case SOURCE.STRAPI:
      return strapiErrorHandler;

    case SOURCE.SMS_V11:
      return smsErrorHandler;

    default:
      return function (error) {
        return Promise.reject(error);
      };
  }
};

var getRelevantResponseHandler = function getRelevantResponseHandler(source) {
  switch (source) {
    case SOURCE.STRAPI:
      return strapiResponseHandler;

    case SOURCE.SMS_V11:
      return smsResponseHandler;

    default:
      return function (response) {
        return response;
      };
  }
};

var getSandboxHeadersForSMSServer = function getSandboxHeadersForSMSServer() {
  return _extends({}, process.env.GATSBY_USE_SANDBOX === "1" && {
    Source: "Sandbox",
    "Sandbox-User-Id": process.env.GATSBY_SANDBOX_USER_ID
  });
};

var getRelevantAuthHeader = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(facilityId, tenantToken, facPublicKey) {
    var apiKey;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(facPublicKey && !tenantToken)) {
            _context.next = 6;
            break;
          }

          _context.next = 3;
          return getEncAndEncodedApiKey(facilityId, facPublicKey);

        case 3:
          _context.t0 = _context.sent;
          _context.next = 7;
          break;

        case 6:
          _context.t0 = "";

        case 7:
          apiKey = _context.t0;
          return _context.abrupt("return", _extends({}, tenantToken && {
            Authorization: "Tenant-Token " + tenantToken
          }, !tenantToken && apiKey && {
            "Api-Key": "Tfw " + apiKey
          }));

        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function getRelevantAuthHeader(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var getHeadersForSMSServer = /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
    var facilityId, tenantToken, facPublicKey, _ref2$noSandboxHeader, noSandboxHeader;

    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          facilityId = _ref2.facilityId, tenantToken = _ref2.tenantToken, facPublicKey = _ref2.facPublicKey, _ref2$noSandboxHeader = _ref2.noSandboxHeader, noSandboxHeader = _ref2$noSandboxHeader === void 0 ? false : _ref2$noSandboxHeader;
          _context2.t0 = _extends;
          _context2.t1 = {
            "Context-Type": "Facility",
            "Context-Id": facilityId
          };
          _context2.next = 5;
          return getRelevantAuthHeader(facilityId, tenantToken, facPublicKey);

        case 5:
          _context2.t2 = _context2.sent;
          _context2.t3 = noSandboxHeader ? {} : getSandboxHeadersForSMSServer();
          return _context2.abrupt("return", (0, _context2.t0)(_context2.t1, _context2.t2, _context2.t3));

        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));

  return function getHeadersForSMSServer(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

var makeApiCall = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(source, requestConfig) {
    var instance;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          instance = getRelevantAxiosInstance(source);

          if (instance) {
            _context.next = 3;
            break;
          }

          throw new Error("Invalid source for API call");

        case 3:
          _context.next = 5;
          return to(instance.request(requestConfig).then(getRelevantResponseHandler(source))["catch"](getRelevantErrorHandler(source)));

        case 5:
          return _context.abrupt("return", _context.sent);

        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function makeApiCall(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var makeSmsApiCall = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(requestConfig) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return makeApiCall(SOURCE.SMS_V11, requestConfig);

        case 2:
          return _context2.abrupt("return", _context2.sent);

        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));

  return function makeSmsApiCall(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

var makeStrapiApiCall = /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(requestConfig) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return makeApiCall(SOURCE.STRAPI, requestConfig);

        case 2:
          return _context3.abrupt("return", _context3.sent);

        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));

  return function makeStrapiApiCall(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchEncryptedId = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var id, facilityId, facPublicKey;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          id = _ref.id, facilityId = _ref.facilityId, facPublicKey = _ref.facPublicKey;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.encryptId(id);
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            facPublicKey: facPublicKey,
            noSandboxHeader: true
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = {
            url: _context.t1,
            method: "GET",
            headers: _context.t2
          };
          _context.next = 9;
          return (0, _context.t0)(_context.t3);

        case 9:
          return _context.abrupt("return", _context.sent);

        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchEncryptedId(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchDecryptedId = /*#__PURE__*/function () {
  var _ref4 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref3) {
    var id, facilityId, facPublicKey;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          id = _ref3.id, facilityId = _ref3.facilityId, facPublicKey = _ref3.facPublicKey;
          _context2.t0 = makeSmsApiCall;
          _context2.t1 = smsEndpoints.decryptPublicId(id);
          _context2.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            facPublicKey: facPublicKey,
            noSandboxHeader: true
          });

        case 5:
          _context2.t2 = _context2.sent;
          _context2.t3 = {
            url: _context2.t1,
            method: "GET",
            headers: _context2.t2
          };
          _context2.next = 9;
          return (0, _context2.t0)(_context2.t3);

        case 9:
          return _context2.abrupt("return", _context2.sent);

        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));

  return function fetchDecryptedId(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var fetchSmsConfigurations = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var configTypes, facilityId, tenantToken, facPublicKey;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          configTypes = _ref.configTypes, facilityId = _ref.facilityId, tenantToken = _ref.tenantToken, facPublicKey = _ref.facPublicKey;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.configurationSearch;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken,
            facPublicKey: facPublicKey
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = {
            view: "tfw",
            filter: [{
              terms: _extends({
                config_type: configTypes,
                entity_type: ["Facility"],
                entity_id: [facilityId]
              }, configTypes.length === 1 && activeStatusFilterApplicableConfigTypes.includes(configTypes[0]) && {
                value: {
                  status: ["Active"]
                }
              })
            }]
          };
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchSmsConfigurations(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchFacility = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var facilityId, facPublicKey;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          facilityId = _ref.facilityId, facPublicKey = _ref.facPublicKey;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.facilitySearch;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            facPublicKey: facPublicKey
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = {
            view: "tfw",
            filter: [{
              terms: {
                id: [facilityId]
              }
            }]
          };
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchFacility(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchHostedFormKey = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var cardProcessorAuthReq, facilityId, tenantToken;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          cardProcessorAuthReq = _ref.cardProcessorAuthReq, facilityId = _ref.facilityId, tenantToken = _ref.tenantToken;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.cardProcessorAuth;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = cardProcessorAuthReq;
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchHostedFormKey(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var makePayment = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var paymentRequest, facilityId, tenantToken;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          paymentRequest = _ref.paymentRequest, facilityId = _ref.facilityId, tenantToken = _ref.tenantToken;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.pay;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = paymentRequest;
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function makePayment(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchFacilityAndGlobalEncKey = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(facilityId) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.keySearch;
          _context.next = 4;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            noSandboxHeader: true
          });

        case 4:
          _context.t2 = _context.sent;
          _context.t3 = {
            url: _context.t1,
            method: "GET",
            headers: _context.t2
          };
          _context.next = 8;
          return (0, _context.t0)(_context.t3);

        case 8:
          return _context.abrupt("return", _context.sent);

        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchFacilityAndGlobalEncKey(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchMultipleFacilityEncKeys = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(facilityIdList) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.facilitiesKeySearch;
          _context.next = 4;
          return getHeadersForSMSServer({
            facilityId: facilityIdList[0],
            noSandboxHeader: true
          });

        case 4:
          _context.t2 = _context.sent;
          _context.t3 = {
            facility_id_list: facilityIdList
          };
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 9;
          return (0, _context.t0)(_context.t4);

        case 9:
          return _context.abrupt("return", _context.sent);

        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchMultipleFacilityEncKeys(_x) {
    return _ref.apply(this, arguments);
  };
}();

var payAndMoveIn = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var paymentReq, facilityId, tenantToken;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          paymentReq = _ref.paymentReq, facilityId = _ref.facilityId, tenantToken = _ref.tenantToken;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.payAndMoveIn;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = paymentReq;
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function payAndMoveIn(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchPaymentInfo = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var paymentInfoReq, facilityId, tenantToken;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          paymentInfoReq = _ref.paymentInfoReq, facilityId = _ref.facilityId, tenantToken = _ref.tenantToken;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.paymentInfo;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = paymentInfoReq;
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          return _context.abrupt("return", (0, _context.t0)(_context.t4));

        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchPaymentInfo(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchUpcomingCharges = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var ledgerId, effectiveDate, facilityId, tenantToken;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          ledgerId = _ref.ledgerId, effectiveDate = _ref.effectiveDate, facilityId = _ref.facilityId, tenantToken = _ref.tenantToken;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.rentalBillAhead;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = {
            ledger_id: ledgerId,
            effective_date: effectiveDate,
            generate: false
          };
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchUpcomingCharges(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchApplicablePromoPlans = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var applicablePromoPlansReq, facilityId, tenantToken, facPublicKey;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          applicablePromoPlansReq = _ref.applicablePromoPlansReq, facilityId = _ref.facilityId, tenantToken = _ref.tenantToken, facPublicKey = _ref.facPublicKey;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.rentalPromoPlans;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken,
            facPublicKey: facPublicKey
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = applicablePromoPlansReq;
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchApplicablePromoPlans(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchRentalInfo = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var rentalInfoReq, facilityId, tenantToken, facPublicKey;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          rentalInfoReq = _ref.rentalInfoReq, facilityId = _ref.facilityId, tenantToken = _ref.tenantToken, facPublicKey = _ref.facPublicKey;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.rentalInfo;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken,
            facPublicKey: facPublicKey
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = rentalInfoReq;
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchRentalInfo(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchLedgerHistory = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var ledgerId, facilityId, tenantToken;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          ledgerId = _ref.ledgerId, facilityId = _ref.facilityId, tenantToken = _ref.tenantToken;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.ledgerHistoryReport;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = {
            ledger_id: ledgerId
          };
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchLedgerHistory(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var payAndReserve = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var paymentReq, facilityId, tenantToken;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          paymentReq = _ref.paymentReq, facilityId = _ref.facilityId, tenantToken = _ref.tenantToken;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.payAndReserve;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = paymentReq;
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function payAndReserve(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchReservation = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var termsFilter, facilityId, tenantToken;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          termsFilter = _ref.termsFilter, facilityId = _ref.facilityId, tenantToken = _ref.tenantToken;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.reservationSearch;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = {
            view: "tfw",
            filter: [{
              terms: termsFilter
            }]
          };
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchReservation(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var tenantSignIn = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var tenantSignInReq, facilityId, facPublicKey;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          tenantSignInReq = _ref.tenantSignInReq, facilityId = _ref.facilityId, facPublicKey = _ref.facPublicKey;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.tenantSignIn;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            facPublicKey: facPublicKey
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = _extends({}, tenantSignInReq, {
            client_type: "Tenant_Facing_Website"
          });
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function tenantSignIn(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var tenantSignOut = /*#__PURE__*/function () {
  var _ref4 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref3) {
    var facilityId, tenantToken;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          facilityId = _ref3.facilityId, tenantToken = _ref3.tenantToken;
          _context2.t0 = makeSmsApiCall;
          _context2.t1 = smsEndpoints.tenantSignOut;
          _context2.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken
          });

        case 5:
          _context2.t2 = _context2.sent;
          _context2.t3 = {
            url: _context2.t1,
            method: "GET",
            headers: _context2.t2
          };
          _context2.next = 9;
          return (0, _context2.t0)(_context2.t3);

        case 9:
          return _context2.abrupt("return", _context2.sent);

        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));

  return function tenantSignOut(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var tenantSignUp = /*#__PURE__*/function () {
  var _ref6 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref5) {
    var tenantSignUpReq, tenantId, facilityId, facPublicKey;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          tenantSignUpReq = _ref5.tenantSignUpReq, tenantId = _ref5.tenantId, facilityId = _ref5.facilityId, facPublicKey = _ref5.facPublicKey;
          _context3.t0 = makeSmsApiCall;
          _context3.t1 = smsEndpoints.tenantSignUp(tenantId);
          _context3.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            facPublicKey: facPublicKey
          });

        case 5:
          _context3.t2 = _context3.sent;
          _context3.t3 = tenantSignUpReq;
          _context3.t4 = {
            url: _context3.t1,
            method: "POST",
            headers: _context3.t2,
            data: _context3.t3
          };
          _context3.next = 10;
          return (0, _context3.t0)(_context3.t4);

        case 10:
          return _context3.abrupt("return", _context3.sent);

        case 11:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));

  return function tenantSignUp(_x3) {
    return _ref6.apply(this, arguments);
  };
}();

var tenantForgotPassword = /*#__PURE__*/function () {
  var _ref8 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref7) {
    var tenantForgotPasswordReq, facilityId, facPublicKey;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          tenantForgotPasswordReq = _ref7.tenantForgotPasswordReq, facilityId = _ref7.facilityId, facPublicKey = _ref7.facPublicKey;
          _context4.t0 = makeSmsApiCall;
          _context4.t1 = smsEndpoints.tenantForgotPassword;
          _context4.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            facPublicKey: facPublicKey
          });

        case 5:
          _context4.t2 = _context4.sent;
          _context4.t3 = tenantForgotPasswordReq;
          _context4.t4 = {
            url: _context4.t1,
            method: "POST",
            headers: _context4.t2,
            data: _context4.t3
          };
          _context4.next = 10;
          return (0, _context4.t0)(_context4.t4);

        case 10:
          return _context4.abrupt("return", _context4.sent);

        case 11:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));

  return function tenantForgotPassword(_x4) {
    return _ref8.apply(this, arguments);
  };
}();

var tenantChangePassword = /*#__PURE__*/function () {
  var _ref10 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref9) {
    var tenantChangePasswordReq, facilityId, tenantToken;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          tenantChangePasswordReq = _ref9.tenantChangePasswordReq, facilityId = _ref9.facilityId, tenantToken = _ref9.tenantToken;
          _context5.t0 = makeSmsApiCall;
          _context5.t1 = smsEndpoints.tenantChangePassword;
          _context5.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken
          });

        case 5:
          _context5.t2 = _context5.sent;
          _context5.t3 = tenantChangePasswordReq;
          _context5.t4 = {
            url: _context5.t1,
            method: "POST",
            headers: _context5.t2,
            data: _context5.t3
          };
          _context5.next = 10;
          return (0, _context5.t0)(_context5.t4);

        case 10:
          return _context5.abrupt("return", _context5.sent);

        case 11:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));

  return function tenantChangePassword(_x5) {
    return _ref10.apply(this, arguments);
  };
}();

var tenantSendAccessCodeForForgotPassword = /*#__PURE__*/function () {
  var _ref12 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(_ref11) {
    var sendAccessCodeReq, facilityId, facPublicKey;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          sendAccessCodeReq = _ref11.sendAccessCodeReq, facilityId = _ref11.facilityId, facPublicKey = _ref11.facPublicKey;
          _context6.t0 = makeSmsApiCall;
          _context6.t1 = smsEndpoints.tenantSendAccessCode;
          _context6.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            facPublicKey: facPublicKey
          });

        case 5:
          _context6.t2 = _context6.sent;
          _context6.t3 = _extends({}, sendAccessCodeReq, {
            source: "Forgot_Password",
            type: "Access_Code"
          });
          _context6.t4 = {
            url: _context6.t1,
            method: "POST",
            headers: _context6.t2,
            data: _context6.t3
          };
          _context6.next = 10;
          return (0, _context6.t0)(_context6.t4);

        case 10:
          return _context6.abrupt("return", _context6.sent);

        case 11:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));

  return function tenantSendAccessCodeForForgotPassword(_x6) {
    return _ref12.apply(this, arguments);
  };
}();

var enableAutoPayForTenant = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var autoPayEnableReq, ledgerId, facilityId, tenantToken;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          autoPayEnableReq = _ref.autoPayEnableReq, ledgerId = _ref.ledgerId, facilityId = _ref.facilityId, tenantToken = _ref.tenantToken;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.tenantAutoPayEnable(ledgerId);
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = autoPayEnableReq;
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function enableAutoPayForTenant(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var disableAutoPayForTenant = /*#__PURE__*/function () {
  var _ref4 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref3) {
    var ledgerId, facilityId, tenantToken;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          ledgerId = _ref3.ledgerId, facilityId = _ref3.facilityId, tenantToken = _ref3.tenantToken;
          _context2.t0 = makeSmsApiCall;
          _context2.t1 = smsEndpoints.tenantAutoPayDisable(ledgerId);
          _context2.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken
          });

        case 5:
          _context2.t2 = _context2.sent;
          _context2.t3 = {
            url: _context2.t1,
            method: "POST",
            headers: _context2.t2
          };
          _context2.next = 9;
          return (0, _context2.t0)(_context2.t3);

        case 9:
          return _context2.abrupt("return", _context2.sent);

        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));

  return function disableAutoPayForTenant(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var fetchTenant = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var termsFilter, facilityId, tenantToken, facPublicKey;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          termsFilter = _ref.termsFilter, facilityId = _ref.facilityId, tenantToken = _ref.tenantToken, facPublicKey = _ref.facPublicKey;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.tenantSearch;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken,
            facPublicKey: facPublicKey
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = {
            view: "tfw",
            filter: [{
              terms: _extends({}, termsFilter, {
                status: ["Active"]
              })
            }]
          };
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchTenant(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var createTenant = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var createTenantReq, facilityId, facPublicKey;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          createTenantReq = _ref.createTenantReq, facilityId = _ref.facilityId, facPublicKey = _ref.facPublicKey;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.tenantCreate;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            facPublicKey: facPublicKey
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = createTenantReq;
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function createTenant(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var updateTenant = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var updateTenantReq, tenantId, facilityId, tenantToken;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          updateTenantReq = _ref.updateTenantReq, tenantId = _ref.tenantId, facilityId = _ref.facilityId, tenantToken = _ref.tenantToken;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.tenantUpdate(tenantId);
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = updateTenantReq;
          _context.t4 = {
            url: _context.t1,
            method: "PUT",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function updateTenant(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchIsTenantDuplicate = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var termsFilter, facilityId, facPublicKey;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          termsFilter = _ref.termsFilter, facilityId = _ref.facilityId, facPublicKey = _ref.facPublicKey;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.isDuplicateTenant;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            facPublicKey: facPublicKey
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = {
            view: "tfw",
            filter: [{
              terms: _extends({}, termsFilter, {
                status: ["Active"]
              })
            }]
          };
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchIsTenantDuplicate(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchUnits = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var _ref$size, size, _ref$view, view, termsFilter, facilityId, tenantToken, facPublicKey;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref$size = _ref.size, size = _ref$size === void 0 ? 100 : _ref$size, _ref$view = _ref.view, view = _ref$view === void 0 ? "tfw" : _ref$view, termsFilter = _ref.termsFilter, facilityId = _ref.facilityId, tenantToken = _ref.tenantToken, facPublicKey = _ref.facPublicKey;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.unitSearch;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            tenantToken: tenantToken,
            facPublicKey: facPublicKey
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = {
            size: size,
            view: view,
            filter: [{
              terms: termsFilter
            }]
          };
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          return _context.abrupt("return", (0, _context.t0)(_context.t4));

        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchUnits(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchUnitAggregation = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var aggregationName, facilityId, facPublicKey;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          aggregationName = _ref.aggregationName, facilityId = _ref.facilityId, facPublicKey = _ref.facPublicKey;
          _context.t0 = makeSmsApiCall;
          _context.t1 = smsEndpoints.unitAggregation;
          _context.next = 5;
          return getHeadersForSMSServer({
            facilityId: facilityId,
            facPublicKey: facPublicKey
          });

        case 5:
          _context.t2 = _context.sent;
          _context.t3 = {
            aggregation_name: aggregationName
          };
          _context.t4 = {
            url: _context.t1,
            method: "POST",
            headers: _context.t2,
            data: _context.t3
          };
          _context.next = 10;
          return (0, _context.t0)(_context.t4);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchUnitAggregation(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchStrapiFacilityDetails = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(queryString, strapiFid) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return makeStrapiApiCall({
            url: allFacilitiesListsEndpoints.allFacilitiesLists({
              strapiFid: strapiFid,
              queryString: queryString
            })
          });

        case 2:
          return _context.abrupt("return", _context.sent);

        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchStrapiFacilityDetails(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var fetchStrapiLocationDetails = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(queryString, locationId) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return makeStrapiApiCall({
            url: allLocationsListsEndpoints.allLocationsLists({
              locationId: locationId,
              queryString: queryString
            })
          });

        case 2:
          return _context.abrupt("return", _context.sent);

        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchStrapiLocationDetails(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var fetchStrapiViewRatesPageDetails = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(queryString, viewRatesPageId) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return makeStrapiApiCall({
            url: viewRatesPagesEndpoints.viewRatesPages({
              viewRatesPageId: viewRatesPageId,
              queryString: queryString
            })
          });

        case 2:
          return _context.abrupt("return", _context.sent);

        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchStrapiViewRatesPageDetails(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export { createTenant, disableAutoPayForTenant, enableAutoPayForTenant, encryptWithPublicKey, fetchApplicablePromoPlans, fetchDecryptedId, fetchEncryptedId, fetchFacility, fetchFacilityAndGlobalEncKey, fetchHostedFormKey, fetchIsTenantDuplicate, fetchLedgerHistory, fetchMultipleFacilityEncKeys, fetchPaymentInfo, fetchRentalInfo, fetchReservation, fetchSmsConfigurations, fetchStrapiFacilityDetails, fetchStrapiLocationDetails, fetchStrapiViewRatesPageDetails, fetchTenant, fetchUnitAggregation, fetchUnits, fetchUpcomingCharges, makePayment, payAndMoveIn, payAndReserve, tenantChangePassword, tenantForgotPassword, tenantSendAccessCodeForForgotPassword, tenantSignIn, tenantSignOut, tenantSignUp, updateTenant };